import React from 'react'
import {
  StyledHeader,
  StyledIconButton,
  StyledExpand,
  StyledWarning,
} from './styled'

interface ISidebar {
  title: string
  warning?: string
  children: any
}

export const Sidebar = ({ title, warning, children }: ISidebar) => (
  <aside>
    {warning && <StyledWarning>{warning}</StyledWarning>}
    <StyledHeader>
      <span>{title}</span>
      <StyledIconButton>
        <StyledExpand />
      </StyledIconButton>
    </StyledHeader>
    <section>{children}</section>
  </aside>
)
